import { getImageUrl } from '../../services/imageService';
import { campaignStyleVars } from '../../utils/campaign';
import './CampaignMedia.css';

/**
 * Shared artwork + copy layer for every campaign placement.
 *
 * The admin controls legibility per campaign rather than per code path:
 * `text_theme` picks the copy colour, `text_position` aligns the block, and
 * `overlay_opacity` sets how hard the scrim knocks the artwork back.
 */
const CampaignMedia = ({
  campaign,
  className = '',
  as: Heading = 'h2',
  showCta = true,
  eager = false,
}) => {
  if (!campaign) return null;

  const desktop = campaign.image_url ? getImageUrl(campaign.image_url) : null;
  const mobile = campaign.mobile_image_url
    ? getImageUrl(campaign.mobile_image_url)
    : desktop;

  const theme = campaign.text_theme === 'dark' ? 'dark' : 'light';
  const position = campaign.text_position || 'left';

  return (
    <div
      className={`campaign-media campaign-media--${theme} campaign-media--${position} ${className}`.trim()}
      style={campaignStyleVars(campaign)}
    >
      <picture>
        {mobile && <source media="(max-width: 768px)" srcSet={mobile} />}
        <img
          src={desktop}
          alt={campaign.title}
          className="campaign-media-img"
          loading={eager ? 'eager' : 'lazy'}
        />
      </picture>

      <div className="campaign-media-scrim" aria-hidden="true" />

      <div className="campaign-media-content">
        {campaign.kicker && (
          <span className="campaign-media-kicker">{campaign.kicker}</span>
        )}
        <Heading className="campaign-media-title">{campaign.title}</Heading>
        {campaign.subtitle && (
          <p className="campaign-media-subtitle">{campaign.subtitle}</p>
        )}
        {showCta && campaign.cta_text && (
          <span className="campaign-media-cta">{campaign.cta_text}</span>
        )}
      </div>
    </div>
  );
};

export default CampaignMedia;
